import { useMemo } from 'react';

const parseStake = (stake) => {
  if (!stake) return 0;
  if (typeof stake === 'number') return stake;
  if (typeof stake !== 'string') return 0;

  const lowerStake = stake.toLowerCase().replace(/[$,]/g, '').trim();
  
  let multiplier = 1;
  if (lowerStake.endsWith('k')) multiplier = 1000;
  else if (lowerStake.endsWith('m')) multiplier = 1000000;
  else if (lowerStake.endsWith('b')) multiplier = 1000000000;

  const numericPart = parseFloat(lowerStake);
  
  if (isNaN(numericPart)) return 0;

  return numericPart * multiplier;
};

export function HolderColumn({ title, color, items, maxStake, titleClassName }) {
  // 按 stake 金额从大到小排序
  const sortedItems = useMemo(() => {
    return [...items].sort((a, b) => parseStake(b.stake) - parseStake(a.stake));
  }, [items]);

  const getBarWidth = (stake) => {
    const parsed = parseStake(stake);
    const percentage = (parsed / maxStake) * 100;
    return percentage;
  };

  const formatStake = (stake) => {
    const parsed = parseStake(stake);
    if (parsed >= 1000) {
      return `$${(parsed / 1000).toFixed(1)}k`;
    }
    return stake;
  };

  return (
    <div className="p-6 rounded-[28px] bg-slate-900/70 border border-slate-700/60 shadow-xl flex flex-col">
      <div className="flex justify-between items-center gap-2">
        <p className={`m-0 ${titleClassName || 'font-semibold text-white text-sm md:text-base'}`}>{title}</p>
      </div>
      {sortedItems.length === 0 ? (
        <div className="mt-4 text-center text-slate-300 text-sm py-8">
          暂无数据
        </div>
      ) : (
        <div className="mt-4 space-y-4">
          {sortedItems.map((holder) => {
            const barWidth = getBarWidth(holder.stake);
            const stakeValue = formatStake(holder.stake);

            return (
              <div key={`${title}-${holder.name}`} className="group">
                {/* Header: Name and Value */}
                <div className="flex items-center justify-between gap-2 mb-1.5">
                  <span className="text-xs md:text-sm text-slate-300 font-medium min-w-0 flex-shrink truncate group-hover:text-white transition-colors">
                    {holder.name}
                  </span>
                  <span className={`text-xs font-mono font-semibold ${
                    color === 'emerald' ? 'text-emerald-400' : 'text-rose-400'
                  }`}>
                    {stakeValue}
                  </span>
                </div>

                {/* Progress Bar */}
                <div className="relative h-2.5 w-full bg-slate-800/50 rounded-full overflow-hidden shadow-inner">
                  <div
                    style={{ width: `${barWidth}%` }}
                    className={`h-full rounded-full shadow-lg transition-all duration-500 ease-out ${
                      color === 'emerald'
                        ? 'bg-gradient-to-r from-emerald-600 to-emerald-400 shadow-[0_0_10px_rgba(16,185,129,0.4)]'
                        : 'bg-gradient-to-r from-rose-600 to-rose-400 shadow-[0_0_10px_rgba(244,63,94,0.4)]'
                    }`}
                  />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
